import * as React from "react";
function SvgArrow(props) {
  return (
    <svg
      viewBox="0 0 17 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.314 1.757l11.313 11.314L2.314 24.385"
        stroke="#fff"
        strokeWidth={4}
      />
    </svg>
  );
}
export default SvgArrow;
